import * as d3 from "d3"
import * as shared from "./shared"
import * as resizeEvents from "./resize"
import * as select from "app/core/components/dashboard/d3/select"
import * as moveEvents from "./move"
import * as multiselectEvents from "./multiselect"
import { DragEvent as D3DragEvent } from "app/core/components/dashboard/d3/types"
import { SvgEventHandlers } from "./types"

export const register = (
  svgElement: SVGSVGElement,
  handlers?: SvgEventHandlers,
  editable?: boolean,
  showSelection?: boolean,
  allowMultiSelect?: boolean,
): (() => void) => {
  d3.select(svgElement).call(
    d3
      .drag()
      .touchable(function () {
        return false
      })
      .filter(function () {
        // ignore drag gestures when buttons cannot be selected
        // this allows the viewer to be scrolled on mobile
        // when the navigation/tab bar obscures some of the content
        return showSelection ?? false
      })
      .container(function () {
        return this as d3.DragContainerElement
      })
      .on("start", (event: D3DragEvent) => {
        const { resizerTarget, buttonTarget } = shared.mouseTarget(event.sourceEvent)
        // quick hack to allow for image buttons, which add an svg containing an image tag
        if (editable) {
          if (buttonTarget) {
            if (showSelection) {
              if (allowMultiSelect && event.sourceEvent.metaKey) {
                select.toggle(buttonTarget)
              } else if (!select.isSelected(buttonTarget)) {
                select.button(buttonTarget, allowMultiSelect && event.sourceEvent.shiftKey)
              }
              handlers?.select?.(select.getSelection(), event.sourceEvent)
            }
            if (resizerTarget) {
              resizeEvents.register(event, resizerTarget, buttonTarget, handlers)
            } else if (buttonTarget) {
              moveEvents.register(event, buttonTarget, handlers)
            }
          } else if (allowMultiSelect) {
            multiselectEvents.register(event, handlers)
          }
        }
      }),
  )

  return () => d3.select(svgElement).on(".drag", null)
}
